<div id="student-edit-overlay" [class]="visibility()">
  <div id="student-edit-container">
    <form id="student-edit-form">
      <label
        id="student-edit-firstname-label"
        for="student-edit-firstname-input"
        >Vorname</label
        >
        <input
          id="student-edit-firstname-input"
          name="student-edit-firstname-input"
          type="text"
          [(ngModel)]="model.firstname" />

          <label id="student-edit-lastname-label" for="student-edit-lastname-input"
            >Nachname</label
            >
            <input
              id="student-edit-lastname-input"
              name="student-edit-lastname-input"
              type="text"
              [(ngModel)]="model.lastname" />

              @if (!simple) {
                <label
                  id="student-edit-birthday-label"
                  for="student-edit-birthday-input"
                  >Geburtsdatum</label
                  >
                  <input
                    id="student-edit-birthday-input"
                    name="student-edit-birthday-input"
                    type="date"
                    [(ngModel)]="model.birthday" />
                    <label id="student-edit-gender-label" for="student-edit-gender-input"
                      >Geschlecht</label
                      >
                      <select
                        id="student-edit-gender-input"
                        name="student-edit-gender-input"
                        [(ngModel)]="model.gender">
                        @for (gender of genders; track gender) {
                          <option [value]="gender.id">
                            {{ gender.text }}
                          </option>
                        }
                      </select>
                      <label id="student-edit-street-label" for="student-edit-street-input"
                        >Strasse</label
                        >
                        <input
                          id="student-edit-street-input"
                          name="student-edit-street-input"
                          type="text"
                          [(ngModel)]="model.street" />
                          <label id="student-edit-house-label" for="student-edit-house-input"
                            >Hausnummer</label
                            >
                            <input
                              id="student-edit-house-input"
                              name="student-edit-house-input"
                              type="text"
                              [(ngModel)]="model.house" />
                              <label
                                id="student-edit-housesuffix-label"
                                for="student-edit-housesuffix-input"
                                >Suffix</label
                                >
                                <input
                                  id="student-edit-housesuffix-input"
                                  name="student-edit-housesuffix-input"
                                  type="text"
                                  [(ngModel)]="model.house_suffix" />
                                  <label id="student-edit-zip-label" for="student-edit-zip-input"
                                    >PLZ</label
                                    >
                                    <input
                                      id="student-edit-zip-input"
                                      name="student-edit-zip-input"
                                      type="text"
                                      [(ngModel)]="model.zip" />
                                      <label id="student-edit-city-label" for="student-edit-city-input"
                                        >Stadt</label
                                        >
                                        <input
                                          id="student-edit-city-input"
                                          name="student-edit-city-input"
                                          type="text"
                                          [(ngModel)]="model.city" />
                                          <label id="student-edit-phone-label" for="student-edit-phone-input"
                                            >Telefon</label
                                            >
                                            <input
                                              id="student-edit-phone-input"
                                              name="student-edit-phone-input"
                                              type="text"
                                              [(ngModel)]="model.phone" />
                                              <label id="student-edit-email-label" for="student-edit-email-input"
                                                >E-Mail</label
                                                >
                                                <input
                                                  id="student-edit-email-input"
                                                  name="student-edit-email-input"
                                                  type="text"
                                                  [(ngModel)]="model.email" />
                                                }
                                              </form>
                                              <div style="text-align: center">
                                                <button class="button-save" (click)="save()">Save</button>
                                                <button class="button-close" (click)="close()">Close</button>
                                              </div>
                                            </div>
                                          </div>
